import { render, staticRenderFns } from "./fukuan.vue?vue&type=template&id=402724da&scoped=true"
import script from "./fukuan.vue?vue&type=script&lang=js"
export * from "./fukuan.vue?vue&type=script&lang=js"
import style0 from "./fukuan.vue?vue&type=style&index=0&id=402724da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402724da",
  null
  
)

export default component.exports